@if (showMarketHelp()) {
    <ms-market-help [optionGroup]="optionGroup()" [eventHelpText]="eventHelpText()" />
}
@if (isShowTabs() && tabs.length) {
    <ds-tabs-group indicator="underline" size="small" [scrollable]="true">
        <ds-tab [name]="tabs[0].title ?? ''" [title]="tabs[0].title ?? ''" />
        <ds-divider />
    </ds-tabs-group>
}
@if (isTeamGroupingEnabled()) {
    <ms-team-grouping-tab-bar [event]="event()" [optionGroup]="optionGroup()" (teamGroupingChange)="onTeamGroupingChange($event)" />
}
<div class="option-group-container player-milestone-container" [ngClass]="isOptionGroupHasTwoOptions() ? 'triple' : 'double'">
    @if (isOverUnder) {
        <div class="option-group-header player-milestone-over-under">
            <span>{{ optionGroup().parameterTranslations?.columnOver }}</span>
            <span>{{ optionGroup().parameterTranslations?.columnUnder }}</span>
        </div>
    } @else {
        <ng-container *msShowInEpcot="false">
            <div class="option-group-header player-milestone-options">
                <span>{{ optionGroup().parameterTranslations?.columnYes }}</span>
                @if (isOptionGroupHasTwoOptions()) {
                    <span>{{ optionGroup().parameterTranslations?.columnNo }}</span>
                }
            </div>
        </ng-container>
    }

    @for (group of optionGroups() | slice: 0 : visibleOptionsLimit(); track group.optionGroupId) {
        <div
            class="attribute-key"
            [class.option-name-stats-container]="showPlayerStats()"
            [class.player-statistics]="optionGroupPlayerStatisticsService.isPlayerStatisticsEnabled()">
            @if (isShowHeadshotImage()) {
                <ms-participant-image
                    class="participant-logo"
                    [participantImage]="getPlayerImage(group)"
                    [showLogoColor]="true"
                    [participantType]="participantType.Player"
                    [sportId]="event().sport.id" />
            }
            <div class="group-title">
                <span class="title">{{ group.attribute }}</span>
                @if (isCrmMarketPromoted(group)) {
                    <ms-promotion-badge class="no-title" />
                }
                @if (showPlayerStats()) {
                    @let eventValue = event();
                    @let optionValue = optionGroup();
                    @if (eventValue.playerStats && optionValue.detailedGrouping.playerStatsProps) {
                        <ms-player-stats
                            [playerStats]="eventValue.playerStats"
                            [sportId]="eventValue.sport.id"
                            [playerStatsProps]="optionValue.detailedGrouping.playerStatsProps"
                            [playerIds]="getPlayers(group)"
                            [source]="optionGroup().source" />
                    }
                } @else if (
                    optionGroupPlayerStatisticsService.isSeasonStatisticsEnabled() &&
                    optionGroupPlayerStatisticsService.isPlayer(event(), group.attribute)
                ) {
                    <ms-player-stats
                        [statistics]="optionGroupPlayerStatisticsService.playerStatistics()"
                        [marketId]="group.optionGroupId?.toString()"
                        [seasonStatisticsMessage]="seasonStatisticsMessage().avg"
                        [isSeasonStatisticsEnabled]="optionGroupPlayerStatisticsService.isSeasonStatisticsEnabled()"
                        [seasonStatisticsType]="SeasonStatisticsType.Average"
                        [marketType]="marketType"
                        [optionId]="group.options[0]?.id?.toString()" />
                }
            </div>
            @if (
                optionGroupPlayerStatisticsService.isPlayerStatisticsEnabled() &&
                optionGroupPlayerStatisticsService.isPlayer(event(), group.attribute)
            ) {
                <div class="player-statistics-icon" [class.active]="isPlayerStatisticsOpen(group)" (click)="togglePlayerStatistics(group)">
                    <vn-icon size="12" [name]="isPlayerStatisticsOpen(group) ? 'sports-stats-active' : 'sports-stats'" />
                </div>
            }
        </div>
        @for (option of group.options; track option.id) {
            <ms-option
                [option]="option"
                [tracking]="{ source: tracking(), moduleType: trackingModuleType() }"
                [optionGroup]="optionGroup()"
                [event]="event()"
                [showPromoBadge]="!!crmPromoIdsMap().options[option.id]"
                [sourceOfPick]="sourceOfPick()"
                [betDetails]="betDetails()" />
        }
        @if (isPlayerStatisticsOpen(group)) {
            <ms-player-statistics
                [statistics]="optionGroupPlayerStatisticsService.playerStatistics()"
                [marketFilter]="optionGroup().originalId"
                [tracking]="tracking()"
                [optionGroupName]="optionGroup().name"
                [messages]="playerStatisticsMessages()"
                [isSheetViewOpen]="optionGroupPlayerStatisticsService.isSheetViewOpen()"
                [event]="event()"
                [marketId]="group.optionGroupId?.toString()"
                [marketType]="marketType"
                [playerName]="group.attribute"
                [iFrameHeight]="optionGroupPlayerStatisticsService.iFrameHeight()"
                [optionId]="group.options[0]?.id?.toString()" />
        }
    }
</div>

@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData()" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}
